DialogController = App.loadClass 'core::Angular/DialogController'

class exports.CopyFieldprintController extends DialogController
    constructor: (
        @scope
        @transitions
        @modalInstance
        @service
        @fpcResultId
        @year
        @fpcResults
        @fields
    ) ->
        super
        @fields = @fields.map (field) =>
            return {
                field_id: field.field_id
                farm_name: field.farm_name
                field_name: field.field_name
                disabled: !!@fpcResults.find (result) => result.fields_id is field.field_id and result.year is parseInt(@year)
            }
        @scope.fields = @fields

        half = Math.round(@fields.length / 2)
        @scope.splitFields = [
            @fields.slice 0, half
            @fields.slice half
        ]

        @scope.save = () =>
            selected = @fields.filter (field) => field.selected
            @service.copy @fpcResultId, selected.map (field) => field.field_id
            .then () =>
                @closeWithAlert
                    type: 'success'
                    msg: 'Successfully copied Fieldprint'
